/* Driven Mods — LED matrix simulator. <dm-led data-cols data-rows data-mode data-text data-color>
   Modes: cycle | brand | text | draw | police | santa | hoho | reindeer | snowman | devil | cute | flames | fireworks | pumpkin | holiday. Pauses off-screen; static frame for reduced motion. */
(function () {
  if (customElements.get('dm-led')) return;

  var FONT = {
    A: ['01110', '10001', '10001', '11111', '10001', '10001', '10001'],
    B: ['11110', '10001', '10001', '11110', '10001', '10001', '11110'],
    C: ['01110', '10001', '10000', '10000', '10000', '10001', '01110'],
    D: ['11110', '10001', '10001', '10001', '10001', '10001', '11110'],
    E: ['11111', '10000', '10000', '11110', '10000', '10000', '11111'],
    F: ['11111', '10000', '10000', '11110', '10000', '10000', '10000'],
    G: ['01110', '10001', '10000', '10111', '10001', '10001', '01111'],
    H: ['10001', '10001', '10001', '11111', '10001', '10001', '10001'],
    I: ['11111', '00100', '00100', '00100', '00100', '00100', '11111'],
    J: ['00111', '00010', '00010', '00010', '00010', '10010', '01100'],
    K: ['10001', '10010', '10100', '11000', '10100', '10010', '10001'],
    L: ['10000', '10000', '10000', '10000', '10000', '10000', '11111'],
    M: ['10001', '11011', '10101', '10101', '10001', '10001', '10001'],
    N: ['10001', '11001', '10101', '10011', '10001', '10001', '10001'],
    O: ['01110', '10001', '10001', '10001', '10001', '10001', '01110'],
    P: ['11110', '10001', '10001', '11110', '10000', '10000', '10000'],
    Q: ['01110', '10001', '10001', '10001', '10101', '10010', '01101'],
    R: ['11110', '10001', '10001', '11110', '10100', '10010', '10001'],
    S: ['01111', '10000', '10000', '01110', '00001', '00001', '11110'],
    T: ['11111', '00100', '00100', '00100', '00100', '00100', '00100'],
    U: ['10001', '10001', '10001', '10001', '10001', '10001', '01110'],
    V: ['10001', '10001', '10001', '10001', '10001', '01010', '00100'],
    W: ['10001', '10001', '10001', '10101', '10101', '10101', '01010'],
    X: ['10001', '10001', '01010', '00100', '01010', '10001', '10001'],
    Y: ['10001', '10001', '01010', '00100', '00100', '00100', '00100'],
    Z: ['11111', '00001', '00010', '00100', '01000', '10000', '11111'],
    0: ['01110', '10001', '10011', '10101', '11001', '10001', '01110'],
    1: ['00100', '01100', '00100', '00100', '00100', '00100', '01110'],
    2: ['01110', '10001', '00001', '00010', '00100', '01000', '11111'],
    3: ['11110', '00001', '00001', '01110', '00001', '00001', '11110'],
    4: ['00010', '00110', '01010', '10010', '11111', '00010', '00010'],
    5: ['11111', '10000', '11110', '00001', '00001', '10001', '01110'],
    6: ['00110', '01000', '10000', '11110', '10001', '10001', '01110'],
    7: ['11111', '00001', '00010', '00100', '01000', '01000', '01000'],
    8: ['01110', '10001', '10001', '01110', '10001', '10001', '01110'],
    9: ['01110', '10001', '10001', '01111', '00001', '00010', '01100'],
    ' ': ['000', '000', '000', '000', '000', '000', '000'],
    '!': ['1', '1', '1', '1', '1', '0', '1'],
    '.': ['0', '0', '0', '0', '0', '0', '1'],
    '-': ['000', '000', '000', '111', '000', '000', '000'],
    "'": ['1', '1', '0', '0', '0', '0', '0'],
    '?': ['01110', '10001', '00001', '00110', '00100', '00000', '00100'],
    '&': ['01100', '10010', '10100', '01000', '10101', '10010', '01101'],
    '<': ['00000', '01010', '11111', '11111', '01110', '00100', '00000'] /* heart */
  };

  var PAL = {
    R: '#ff2a1f', W: '#fff4e6', S: '#ffc9a3', K: null, G: '#22e05a', Y: '#ffd21f',
    B: '#3d8bff', T: '#a0522d', P: '#ff4fa3', O: '#ff8a1f', C: '#7fe9ff'
  };

  var SANTA = [
    '.......RRRR..WW',
    '.....RRRRRRRRWW',
    '....RRRRRRRR...',
    '...WWWWWWWWWW..',
    '...SSSSSSSSSS..',
    '...SKSSSSSSKS..',
    '...SSSSSRSSSS..',
    '..WWWWSSSSWWWW.',
    '..WWWWWWWWWWWW.',
    '...WWWWWWWWWW..',
    '....WWWWWWWW...',
    '.....WWWWWW....',
    '......WWWW.....'
  ];
  var TREE = [
    '....Y....',
    '...GGG...',
    '..GGRGG..',
    '...GGG...',
    '..GGGGG..',
    '.GGYGGBG.',
    '..GGGGG..',
    '.GGRGGGG.',
    'GGGGGYGGG',
    '...TTT...',
    '...TTT...'
  ];
  var EYE = [
    'RR..............',
    'RRRRR...........',
    '.RRRRRRRR.......',
    '..RRRRRRRRRRR...',
    '...RRRRRRRRRRRR.',
    '....RRRRRRRRRR..',
    '......RRRRRR....'
  ];
  var HEART = ['.PP.PP.', 'PPPPPPP', 'PPPPPPP', '.PPPPP.', '..PPP..', '...P...'];
  var DEVIL = [
    'RRR...............',
    'RRRRRR............',
    '.RROORRRRR........',
    '.ROOOOOOORRRR.....',
    '..ROOYYYYOOOORRR..',
    '..ROYYYYYYYOOOORRR',
    '...ROYYYYYYYOOORR.',
    '....RROOYYYOOORR..',
    '......RRRRRRRR....'
  ];
  var EYEBALL = [
    '...WWW...',
    '.WWWWWWW.',
    '.WWWWWWW.',
    'WWWWWWWWW',
    'WWWWWWWWW',
    'WWWWWWWWW',
    '.WWWWWWW.',
    '.WWWWWWW.',
    '...WWW...'
  ];
  var REINDEER = [
    'T..T.......T..T',
    'TT.T.......T.TT',
    '.TTT.......TTT.',
    '...T.......T...',
    '...TTTTTTTTT...',
    'TTTTTTTTTTTTTTT',
    '...TTWTTTWTT...',
    '...TTTTTTTTT...',
    '....TTTTTTT....',
    '....TTTTTTT....',
    '.....TRRRT.....',
    '......RRR......'
  ];
  var SNOWMAN = [
    '...RRRRR...',
    '...RRRRR...',
    '..RRRRRRR..',
    '...WWWWW...',
    '..WW.W.WW..',
    '..WWWWOOW..',
    '...W...W...',
    '....WWW....',
    '..WWWWWWW..',
    '.WWWWRWWWW.',
    'WWWWWWWWWWW',
    'WWWWWRWWWWW',
    'WWWWWWWWWWW',
    '.WWWWWWWWW.',
    '..WWWWWWW..'
  ];
  var PUMPKIN = [
    '......GG.....',
    '.....GG......',
    '..OOOOOOOOO..',
    '.OOOOOOOOOOO.',
    'OOYYYOOOYYYOO',
    'OOOYOOOOOYOOO',
    'OOOOOOYOOOOOO',
    'OYOOYYYYYOOYO',
    'OOYYYYYYYYYOO',
    '.OOOYOOOYOOO.',
    '..OOOOOOOOO..'
  ];

  function Frame(cols, rows) {
    this.c = cols; this.r = rows; this.px = new Array(cols * rows);
  }
  Frame.prototype.clear = function () { this.px.fill(null); };
  Frame.prototype.off = function (x, y) {
    x = Math.round(x); y = Math.round(y);
    if (x >= 0 && y >= 0 && x < this.c && y < this.r) this.px[y * this.c + x] = null;
  };
  function dim(hex, k) {
    var n = parseInt(hex.slice(1), 16);
    return 'rgb(' + Math.round((n >> 16) * k) + ',' + Math.round(((n >> 8) & 255) * k) + ',' + Math.round((n & 255) * k) + ')';
  }
  function hash(i) { var x = Math.sin(i * 127.1 + 311.7) * 43758.5453; return x - Math.floor(x); }
  Frame.prototype.set = function (x, y, col) {
    x = Math.round(x); y = Math.round(y);
    if (x < 0 || y < 0 || x >= this.c || y >= this.r || !col) return;
    this.px[y * this.c + x] = col;
  };
  Frame.prototype.sprite = function (map, x0, y0, mirror, colorFn) {
    for (var y = 0; y < map.length; y++) {
      var row = map[y];
      for (var x = 0; x < row.length; x++) {
        var ch = row[mirror ? row.length - 1 - x : x];
        if (ch === '.') continue;
        var col = colorFn ? colorFn(ch, x, y) : PAL[ch];
        this.set(x0 + x, y0 + y, col);
      }
    }
  };

  function textWidth(str) {
    var w = 0;
    for (var i = 0; i < str.length; i++) { var g = FONT[str[i]] || FONT[' ']; w += g[0].length + 1; }
    return w - 1;
  }
  function drawText(f, str, x0, y0, colorFn) {
    var x = x0;
    for (var i = 0; i < str.length; i++) {
      var g = FONT[str[i]] || FONT[' '];
      for (var y = 0; y < 7; y++) for (var gx = 0; gx < g[y].length; gx++) {
        if (g[y][gx] === '1') f.set(x + gx, y0 + y, colorFn ? colorFn(i, str[i]) : '#fff4e6');
      }
      x += g[0].length + 1;
    }
  }

  /* ---------- scenes: (frame, t seconds, opts) ---------- */
  function sceneText(f, t, o) {
    var str = (o.text || 'DRIVEN MODS').toUpperCase();
    var w = textWidth(str), y = Math.floor((f.r - 7) / 2);
    var col = o.color || '#fff4e6';
    if (w <= f.c - 4) {
      drawText(f, str, Math.floor((f.c - w) / 2), y, function () { return col; });
    } else {
      var x = o.still ? 1 : f.c - ((t * 22) % (w + f.c));
      drawText(f, str, x, y, function () { return col; });
    }
  }
  function sceneSanta(f, t) {
    var cx = Math.floor(f.c / 2) - 7, y = Math.max(0, Math.floor((f.r - 13) / 2));
    var bob = Math.round(Math.sin(t * 3) * 0.6);
    f.sprite(SANTA, cx, y + bob);
    if (f.c >= 44) {
      f.sprite(TREE, cx - 14, f.r - 11);
      f.sprite(TREE, cx + 20, f.r - 11, false, function (ch) {
        return ch === 'Y' || ch === 'R' || ch === 'B' ? (Math.sin(t * 6) > 0 ? PAL[ch] : PAL.Y) : PAL[ch];
      });
    }
    for (var i = 0; i < Math.floor(f.c / 4); i++) {
      var sx = (i * 37) % f.c, sp = 2 + (i % 3);
      var sy = ((t * sp + i * 5.3) % (f.r + 2)) - 1;
      f.set(sx + Math.sin(t + i) * 1.2, sy, i % 4 === 0 ? PAL.C : '#ffffff');
    }
  }
  function sceneDevil(f, t) {
    var gap = Math.max(4, Math.floor(f.c / 10)), y = Math.floor((f.r - 7) / 2);
    var lx = Math.floor(f.c / 2) - gap / 2 - 16, rx = Math.floor(f.c / 2) + gap / 2;
    var blink = (t % 4) > 3.82;
    var map = blink ? [EYE[3], EYE[4]] : EYE;
    var yo = blink ? y + 3 : y;
    var glow = 0.75 + 0.25 * Math.sin(t * 2);
    var red = 'rgba(255,' + Math.round(30 * glow) + ',20,1)';
    f.sprite(map, lx, yo, false, function () { return red; });
    f.sprite(map, rx, yo, true, function () { return red; });
  }
  function sceneHoliday(f, t) {
    var n = Math.max(2, Math.floor(f.c / 10));
    for (var i = 0; i < n; i++) {
      var x = Math.round((i + 0.5) * (f.c / n)) - 3;
      var y = Math.floor((f.r - 6) / 2) + Math.round(Math.sin(t * 3 + i) * 1.5);
      f.sprite(HEART, x, y, false, function (ch) { return i % 2 ? PAL.R : PAL.P; });
    }
  }
  function sceneHoHo(f, t) {
    var str = 'HO HO HO', w = textWidth(str);
    var x = Math.floor((f.c - w) / 2), y = Math.floor((f.r - 7) / 2);
    drawText(f, str, x, y, function (i) {
      var on = Math.floor(t * 3 + i) % 2; return on ? PAL.R : PAL.G;
    });
  }

  /* Brand intro (6.5 s): DRIVEN drops in letter by letter, slides up, MODS rises in, then it settles on
     DRIVEN MODS with a red line drawn underneath. A soft light sweep runs across whatever is lit. */
  function easeOut(p) { p = Math.max(0, Math.min(1, p)); return 1 - Math.pow(1 - p, 3); }
  function drawWord(f, str, k, x0, y0, letterDy, color) {
    var x = x0;
    for (var i = 0; i < str.length; i++) {
      var g = FONT[str[i]] || FONT[' '], dy = letterDy ? letterDy(i) : 0;
      if (dy !== null) for (var gy = 0; gy < 7; gy++) for (var gx = 0; gx < g[gy].length; gx++) {
        if (g[gy][gx] !== '1') continue;
        for (var a = 0; a < k; a++) for (var b = 0; b < k; b++) {
          var px = x + gx * k + b, py = Math.round(y0 + dy) + gy * k + a;
          f.set(px, py, color(px, py));
        }
      }
      x += (g[0].length + 1) * k;
    }
  }
  function wordWidth(str, k) { return textWidth(str) * k + (str.length - 1) * (k - 1); }
  function sceneBrand(f, t, o) {
    var sweep = ((t * 34) % (f.c + 40)) - 20;
    var shine = function (px) { var d = (px - sweep) / 5; return dim('#fff4e6', 0.62 + 0.38 * Math.exp(-d * d)); };
    if (f.r < 15) { sceneText(f, t, { text: 'DRIVEN MODS' }); return; }
    var k = 2, y0 = Math.floor((f.r - 14) / 2), A = 'DRIVEN', B = 'MODS';
    var xA = Math.floor((f.c - wordWidth(A, k)) / 2), xB = Math.floor((f.c - wordWidth(B, k)) / 2);
    if (t < 2.0) {
      drawWord(f, A, k, xA, y0, function (i) { var p = (t - i * 0.12) / 0.35; return p <= 0 ? null : -(1 - easeOut(p)) * (f.r + 2); }, shine);
    } else if (t < 2.6) {
      var q = easeOut((t - 2.0) / 0.6);
      drawWord(f, A, k, xA, y0 - q * (f.r + 2), null, shine);
      drawWord(f, B, k, xB, y0 + (1 - q) * (f.r + 2), null, shine);
    } else if (t < 3.7) {
      drawWord(f, B, k, xB, y0, null, shine);
    } else if (t < 4.1) {
      drawWord(f, B, k, xB, y0 + easeOut((t - 3.7) / 0.4) * (f.r + 2), null, shine);
    } else {
      var str = 'DRIVEN MODS', w = textWidth(str), x0 = Math.floor((f.c - w) / 2), y1 = Math.floor((f.r - 7) / 2) - 1;
      var reveal = x0 + easeOut((t - 4.1) / 0.5) * (w + 1);
      drawWord(f, str, 1, x0, y1, null, function (px) { return px <= reveal ? shine(px) : null; });
      var half = easeOut((t - 4.5) / 0.6) * (w / 2 + 1), cx = f.c / 2;
      for (var lx = Math.ceil(cx - half); lx < cx + half; lx++) f.set(lx, y1 + 9, PAL.R);
    }
  }
  /* Police-style wig-wag: red half flashes three times, then the blue half, with a bright band sweeping across the lit half. */
  function scenePolice(f, t) {
    var step = Math.floor(t * 12) % 12, red = step < 6, on = step % 2 === 0;
    var mid = Math.floor(f.c / 2), sweep = (t * 3) % 1;
    for (var side = 0; side < 2; side++) {
      var isRed = side === 0, lit = on && (isRed === red);
      var x0 = isRed ? 1 : mid + 1, x1 = isRed ? mid - 1 : f.c - 1, base = isRed ? '#ff2a1f' : '#2f6bff';
      for (var y = 1; y < f.r - 1; y++) for (var x = x0; x < x1; x++) {
        if (!lit) { f.set(x, y, dim(base, 0.12)); continue; }
        var d = (x - (x0 + (x1 - x0) * (isRed ? 1 - sweep : sweep))) / 4;
        f.set(x, y, dim(base, 0.75 + 0.25 * Math.exp(-d * d)));
      }
    }
  }
  /* Angry slanted eyes like the viral rear-window clips: red rim, orange-yellow core, slit pupils that look around. */
  function sceneDevilV2(f, t) {
    var w = DEVIL[0].length, gap = Math.max(4, Math.floor(f.c / 12));
    if (f.c < w * 2 + gap || f.r < DEVIL.length) { sceneDevil(f, t); return; }
    var y = Math.floor((f.r - DEVIL.length) / 2), lx = Math.floor(f.c / 2 - gap / 2 - w), rx = Math.ceil(f.c / 2 + gap / 2);
    var glow = 0.78 + 0.22 * Math.sin(t * 2.2);
    var squint = (t % 5) > 4.75;
    var look = Math.round(Math.sin(t * 0.9) * 2.4);
    [[lx, false], [rx, true]].forEach(function (e) {
      f.sprite(DEVIL, e[0], y, e[1], function (ch, x, yy) {
        if (squint && (yy < 3 || yy > 6)) return null;
        return dim(PAL[ch], glow);
      });
      var px = e[0] + 8 + look;
      for (var yy = 3; yy <= 7; yy++) {
        if (squint && (yy < 3 || yy > 6)) continue;
        f.off(px, y + yy); if (yy > 3 && yy < 7) f.off(px + 1, y + yy);
      }
    });
  }
  /* Big friendly eyes with sparkle, blink and a little blush. */
  function sceneCute(f, t) {
    var w = EYEBALL[0].length, gap = Math.max(6, Math.floor(f.c / 6));
    var y = Math.floor((f.r - EYEBALL.length) / 2) - (f.r >= 14 ? 1 : 0);
    var lx = Math.floor(f.c / 2 - gap / 2 - w), rx = Math.ceil(f.c / 2 + gap / 2);
    var blink = (t % 3.6) > 3.42;
    var dx = Math.round(Math.sin(t * 0.8)), dy = Math.round(Math.sin(t * 0.53));
    [lx, rx].forEach(function (x0) {
      if (blink) { for (var x = 1; x < w - 1; x++) f.set(x0 + x, y + 5, PAL.W); return; }
      f.sprite(EYEBALL, x0, y);
      for (var py = 3; py <= 5; py++) for (var px = 3; px <= 5; px++) f.off(x0 + px + dx, y + py + dy);
      f.set(x0 + 3 + dx, y + 3 + dy, '#ffffff');
      if (f.r >= 14) { f.set(x0 - 1, y + 10, PAL.P); f.set(x0, y + 10, PAL.P); f.set(x0 + w - 1, y + 10, PAL.P); f.set(x0 + w, y + 10, PAL.P); }
    });
  }
  function sceneFlames(f, t) {
    for (var x = 0; x < f.c; x++) {
      var n = Math.sin(x * 0.9 + t * 7) * 0.5 + Math.sin(x * 0.37 - t * 5.3) * 0.5 + Math.sin(x * 1.7 + t * 11) * 0.25;
      var h = f.r * (0.58 + 0.24 * n);
      for (var y = 0; y < f.r; y++) {
        var d = (f.r - 1 - y) / h;
        if (d >= 1) continue;
        f.set(x, y, d < 0.22 ? '#fff1b0' : d < 0.48 ? PAL.Y : d < 0.75 ? PAL.O : PAL.R);
      }
    }
    for (var i = 0; i < Math.floor(f.c / 8); i++) {
      var sp = (t * 0.9 + hash(i)) % 1;
      f.set(hash(i + 7) * f.c + Math.sin(t * 3 + i) * 1.5, f.r * (1 - sp * 1.1), sp < 0.6 ? PAL.O : PAL.R);
    }
  }
  function sceneFireworks(f, t) {
    var cols = [PAL.R, PAL.Y, PAL.C, PAL.P, PAL.G, PAL.W], period = 1.8;
    for (var k = 0; k < 4; k++) {
      var start = k * 0.45, cyc = Math.floor((t - start) / period), p = (t - start) - cyc * period;
      if (t < start) continue;
      var seed = cyc * 3 + k, x0 = Math.round((0.15 + 0.7 * hash(seed)) * f.c), peak = Math.round(f.r * (0.22 + 0.25 * hash(seed + 1)));
      var col = cols[Math.floor(hash(seed + 2) * cols.length)];
      if (p < 0.55) {
        var yy = f.r - 1 - (f.r - 1 - peak) * (p / 0.55);
        f.set(x0, yy, '#ffe9c4'); f.set(x0, yy + 1, dim('#ff8a1f', 0.6));
      } else {
        var q = p - 0.55, rad = Math.min(1, q / 0.6) * Math.min(f.r * 0.42, 9), fade = q < 0.8 ? 1 : Math.max(0, 1 - (q - 0.8) / 0.45);
        if (fade <= 0) continue;
        for (var a = 0; a < 16; a++) {
          var ang = a / 16 * 6.2832;
          f.set(x0 + Math.cos(ang) * rad * 1.3, peak + Math.sin(ang) * rad + q * q * 3, dim(col, fade));
        }
      }
    }
  }
  function sceneReindeer(f, t) {
    var x = Math.floor((f.c - REINDEER[0].length) / 2), y = Math.max(0, Math.floor((f.r - REINDEER.length) / 2));
    var on = Math.floor(t * 2) % 2;
    f.sprite(REINDEER, x, y, false, function (ch) { return ch === 'R' ? (on ? '#ff2a1f' : '#7a1410') : PAL[ch]; });
    for (var i = 0; i < Math.floor(f.c / 5); i++) {
      var sx = (i * 37) % f.c, sy = ((t * (2 + i % 3) + i * 5.3) % (f.r + 2)) - 1;
      if (Math.abs(sx - f.c / 2) > REINDEER[0].length / 2 + 1) f.set(sx + Math.sin(t + i), sy, '#ffffff');
    }
  }
  function sceneSnowman(f, t) {
    var x = Math.floor((f.c - SNOWMAN[0].length) / 2), y = Math.max(0, f.r - SNOWMAN.length);
    for (var i = 0; i < Math.floor(f.c / 3); i++) {
      var sx = (i * 29) % f.c, sy = ((t * (1.5 + i % 3) + i * 3.7) % (f.r + 2)) - 1;
      f.set(sx + Math.sin(t * 1.3 + i), sy, i % 5 ? '#ffffff' : PAL.C);
    }
    f.sprite(SNOWMAN, x, y);
  }
  function scenePumpkin(f, t) {
    var x = Math.floor((f.c - PUMPKIN[0].length) / 2), y = Math.floor((f.r - PUMPKIN.length) / 2);
    var fl = 0.7 + 0.3 * Math.abs(Math.sin(t * 9) * Math.sin(t * 3.7));
    f.sprite(PUMPKIN, x, y, false, function (ch) { return ch === 'Y' ? dim('#fff4b0', fl) : ch === 'O' ? '#d9480f' : PAL[ch]; });
  }

  var SCENES = { text: sceneText, santa: sceneSanta, devil: sceneDevilV2, holiday: sceneHoliday, hoho: sceneHoHo,
    cute: sceneCute, brand: sceneBrand, police: scenePolice, flames: sceneFlames, fireworks: sceneFireworks, reindeer: sceneReindeer, snowman: sceneSnowman, pumpkin: scenePumpkin };
  var CYCLE = [
    ['brand', 6.5],
    ['santa', 4.5],
    ['reindeer', 3.5],
    ['devil', 5.5],
    ['flames', 3.5],
    ['text', 0, { text: 'SAY IT FROM THE BACK', color: '#ffb547' }],
    ['fireworks', 4],
    ['holiday', 3.5]
  ];

  class DmLed extends HTMLElement {
    connectedCallback() {
      this.cols = parseInt(this.dataset.cols || '64', 10);
      this.rows = parseInt(this.dataset.rows || '20', 10);
      this.mode = this.dataset.mode || 'cycle';
      this.opts = { text: this.dataset.text, color: this.dataset.color };
      this.frame = new Frame(this.cols, this.rows);
      this.canvas = document.createElement('canvas');
      this.canvas.setAttribute('aria-hidden', 'true');
      this.appendChild(this.canvas);
      this.ctx = this.canvas.getContext('2d');
      this.glow = document.createElement('canvas');
      this.gctx = this.glow.getContext('2d');
      this.reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.visible = false;
      this.t0 = performance.now();
      this.resize = this.resize.bind(this);
      this.tick = this.tick.bind(this);
      this.ro = new ResizeObserver(this.resize); this.ro.observe(this);
      var self = this;
      this.io = new IntersectionObserver(function (es) {
        self.visible = es[0].isIntersecting;
        if (self.visible && !self.raf && !self.timer) self.raf = requestAnimationFrame(self.tick);
      }, { rootMargin: '100px' });
      this.io.observe(this);
      this.resize();
    }
    show(mode, opts) {
      this.mode = mode; this.opts = opts || {}; this.t0 = performance.now();
      this.draw(0);
      if (this.visible && !this.raf && !this.timer) this.raf = requestAnimationFrame(this.tick);
    }
    /* Draw mode: paint the LED under a client point (and the line from the last point, so fast strokes have no gaps). */
    paintAt(clientX, clientY, color, fresh) {
      var r = this.canvas.getBoundingClientRect();
      var x = Math.floor((clientX - r.left) / r.width * this.cols), y = Math.floor((clientY - r.top) / r.height * this.rows);
      if (!this.drawBuf) this.drawBuf = new Array(this.cols * this.rows);
      var last = fresh ? null : this.lastPaint, steps = last ? Math.max(Math.abs(x - last[0]), Math.abs(y - last[1]), 1) : 1;
      for (var s = 0; s <= steps; s++) {
        var px = last ? Math.round(last[0] + (x - last[0]) * s / steps) : x, py = last ? Math.round(last[1] + (y - last[1]) * s / steps) : y;
        if (px >= 0 && py >= 0 && px < this.cols && py < this.rows) this.drawBuf[py * this.cols + px] = color;
      }
      this.lastPaint = [x, y];
      this.draw(0);
    }
    clearDrawing() { this.drawBuf = null; this.lastPaint = null; this.draw(0); }
    disconnectedCallback() {
      if (this.ro) this.ro.disconnect();
      if (this.io) this.io.disconnect();
      if (this.raf) cancelAnimationFrame(this.raf);
      if (this.timer) clearTimeout(this.timer);
    }
    resize() {
      var w = this.clientWidth || 320, dpr = Math.min(window.devicePixelRatio || 1, 2);
      this.pitch = w / this.cols;
      var h = this.pitch * this.rows;
      this.canvas.style.width = w + 'px'; this.canvas.style.height = h + 'px';
      this.canvas.width = this.glow.width = Math.round(w * dpr);
      this.canvas.height = this.glow.height = Math.round(h * dpr);
      this.dpr = dpr;
      this.draw((performance.now() - this.t0) / 1000);
    }
    scene(t) {
      var f = this.frame; f.clear();
      if (this.reduced && this.mode === 'cycle') { sceneSanta(f, 0); return; }
      if (this.mode === 'draw') {
        var buf = this.drawBuf || [], any = false;
        for (var i = 0; i < buf.length; i++) if (buf[i]) { f.px[i] = buf[i]; any = true; }
        if (!any) sceneText(f, 0, { text: 'DRAW HERE', color: '#4a4640' });
        return;
      }
      if (this.mode !== 'cycle') {
        var o = this.reduced ? Object.assign({ still: true }, this.opts) : this.opts;
        (SCENES[this.mode] || sceneText)(f, t, o); return;
      }
      var cols = f.c, dur = function (e) {
        if (e[1]) return e[1];
        var w = textWidth(e[2].text.toUpperCase());
        return w <= cols - 4 ? 3.5 : (w + cols) / 22 + 0.3;
      };
      var total = 0, i; for (i = 0; i < CYCLE.length; i++) total += dur(CYCLE[i]);
      var at = t % total;
      for (i = 0; i < CYCLE.length; i++) {
        var d = dur(CYCLE[i]);
        if (at < d) { SCENES[CYCLE[i][0]](f, at, CYCLE[i][2] || {}); return; }
        at -= d;
      }
    }
    draw(t) {
      if (!this.ctx) return;
      this.scene(t);
      var ctx = this.ctx, g = this.gctx, p = this.pitch * this.dpr, f = this.frame;
      var W = this.canvas.width, H = this.canvas.height, rOn = p * 0.4, rOff = p * 0.3;
      ctx.clearRect(0, 0, W, H); g.clearRect(0, 0, W, H);
      ctx.fillStyle = '#18181a';
      for (var y = 0; y < f.r; y++) for (var x = 0; x < f.c; x++) {
        if (f.px[y * f.c + x]) continue;
        ctx.beginPath(); ctx.arc((x + 0.5) * p, (y + 0.5) * p, rOff, 0, 6.2832); ctx.fill();
      }
      for (y = 0; y < f.r; y++) for (x = 0; x < f.c; x++) {
        var col = f.px[y * f.c + x]; if (!col) continue;
        g.fillStyle = col; g.beginPath(); g.arc((x + 0.5) * p, (y + 0.5) * p, rOn, 0, 6.2832); g.fill();
      }
      ctx.save();
      ctx.globalCompositeOperation = 'lighter';
      ctx.filter = 'blur(' + Math.max(2, p * 0.7) + 'px)'; ctx.globalAlpha = 0.85; ctx.drawImage(this.glow, 0, 0);
      ctx.filter = 'none'; ctx.globalAlpha = 1; ctx.drawImage(this.glow, 0, 0);
      ctx.restore();
    }
    tick(now) {
      this.raf = null;
      if (!this.visible) return;
      this.draw((now - this.t0) / 1000);
      if (this.reduced) return;
      var self = this;
      this.timer = setTimeout(function () { self.timer = null; self.raf = requestAnimationFrame(self.tick); }, 50);
    }
  }
  customElements.define('dm-led', DmLed);
  window.DmLedScenes = { Frame: Frame, SCENES: SCENES, CYCLE: CYCLE, textWidth: textWidth };
})();
